// extracted by mini-css-extract-plugin
export default {"modal-content":"LoginModal_modal-content__k4-GE","login-section":"LoginModal_login-section__+wupF","menu-item":"LoginModal_menu-item__HnC9P","icon":"LoginModal_icon__2+R-j"};